module.exports = new __parcel__URL__("hud_quests_button.891b250d.png").toString();